import { enqueueSnackbar, closeSnackbar } from 'notistack';
import { Icon } from '@iconify/react';
import closeFill from '@iconify-icons/eva/close-fill';
import { MIconButton } from '@shared/components/@material-extend';
import i18next from 'i18next';

type NotistackVariant = 'default' | 'warning' | 'info' | 'error' | 'success' | undefined;

/**
 * OSI-806: приводит пойманную ошибку к СТРОКЕ для notifications.error/warning.
 *
 * Ошибки прилетают в двух видах:
 *  - строка — бизнес-ошибка бэка, response-интерцептор делает `if (code !== 0) throw message`
 *    (например «Указан неверный счет» от атрибута [Iban]);
 *  - Error/AxiosError — транспортная ошибка.
 * Раньше в notifications.error передавали сам объект: i18next.t(Error) выдавал мусор,
 * а проверки вида `if (e instanceof Error)` полностью глотали текст бэка (он строка).
 * undefined на выходе означает «показать общий common:error».
 */
export const getErrorText = (e: unknown): string | undefined => {
  if (typeof e === 'string' && e.trim()) return e;
  if (e instanceof Error && e.message) return e.message;
  return undefined;
};

export const notifications = {
  warning(msgToken?: string) {
    this.toast(i18next.t(msgToken || 'common:warning'), 'warning');
  },
  info(msgToken?: string) {
    this.toast(i18next.t(msgToken || 'common:info'), 'info');
  },
  error(msgToken?: string) {
    this.toast(i18next.t(msgToken || 'common:error'), 'error');
  },
  success(msgToken?: string) {
    this.toast(i18next.t(msgToken || 'common:success'), 'success');
  },
  saved() {
    this.toast(i18next.t('common:saved'), 'success');
  },
  noAuth() {
    this.error('common:noAuth');
  },

  toast(msg: string, variant: NotistackVariant = 'default') {
    enqueueSnackbar(msg, {
      variant,
      autoHideDuration: 5000,
      preventDuplicate: true,
      action: (key) => (
        <MIconButton size="small" onClick={() => closeSnackbar(key)}>
          <Icon icon={closeFill} />
        </MIconButton>
      )
    });
  }
};
